import { useQuery } from '@tanstack/react-query'
import { providerApiClient } from '@/lib/api'
import { visitKeys } from '@/lib/queryKeys'

export function useCaseReview(visitId: string) {
  return useQuery({
    queryKey: visitKeys.detail(visitId),
    queryFn: () => providerApiClient.getVisitDetail(visitId),
    enabled: !!visitId,
  })
}
